const FALLBACK_MESSAGE =
    "Si è verificato un errore imprevisto. Riprova tra qualche minuto.";

  const STATUS_MESSAGES = {
    400: "La richiesta non è valida. Verifica i dati inseriti e riprova.",
    401: "La sessione è scaduta. Effettua nuovamente l'accesso.",
    403: "Non sei autorizzato a usare questa funzionalità. Contatta l'amministratore per richiedere l'abilitazione.",
    404: "La risorsa richiesta non è disponibile.",
    500: "Il servizio è temporaneamente non disponibile. Riprova tra qualche minuto.",
  };

  const getStatusCode = (error) => {
    return error?.response?.status || error?.status || null;
  };

  const getResponseData = (error) => {
    return error?.response?.data || error?.data || null;
  };

  const extractBackendDetail = (detail) => {
    if (!detail) {
      return null;
    }

    if (typeof detail === "string") {
      return detail;
    }

    if (Array.isArray(detail)) {
      const messages = detail
        .map((item) => item?.msg || item?.message || item?.detail)
        .filter(Boolean);

      return messages.length > 0 ? messages.join(" ") : null;
    }

    if (typeof detail === "object") {
      return detail.message || detail.detail || null;
    }

    return null;
  };

  export const getApiErrorMessage = (error) => {
    if (typeof error === "string") {
      return error;
    }

    const status = getStatusCode(error);
    const responseData = getResponseData(error);
    const backendDetail = extractBackendDetail(responseData?.detail);

    if (status === 403) {
      return STATUS_MESSAGES[403];
    }

    if (backendDetail) {
      return backendDetail;
    }

    if (status && STATUS_MESSAGES[status]) {
      return STATUS_MESSAGES[status];
    }

    if (error?.message === "Network Error") {
      return "Impossibile raggiungere il server. Verifica la connessione e riprova.";
    }

    return FALLBACK_MESSAGE;
  };